"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireDefault(require("react"));
var _ListItem = _interopRequireDefault(require("@mui/material/ListItem"));
var _ListItemIcon = _interopRequireDefault(require("@mui/material/ListItemIcon"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _ListItemText = _interopRequireDefault(require("@mui/material/ListItemText"));
var _Cancel = _interopRequireDefault(require("@mui/icons-material/Cancel"));
var _Error = _interopRequireDefault(require("@mui/icons-material/Error"));
var _Delete = _interopRequireDefault(require("@mui/icons-material/Delete"));
var _colors = _interopRequireDefault(require("../theme/colors"));
var _Text = _interopRequireDefault(require("./Text"));
var dates = _interopRequireWildcard(require("../services/dates"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @param notification
 * @param onClick
 * @param classes
 * @param id
 * @param testId
 * @returns {*}
 * @constructor
 */
var Notification = function Notification(_ref) {
  var notification = _ref.notification,
    _onClick = _ref.onClick,
    classes = _ref.classes,
    id = _ref.id,
    testId = _ref.testId,
    customDeleteIcon = _ref.customDeleteIcon;
  var timestamp = dates.formatDateForDisplay(notification.timestamp, 'lll');
  var styles = {
    listItemIcon: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      width: 35
    },
    listItem: {
      maxWidth: 800,
      borderRadius: 2,
      boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginBottom: 5,
      minWidth: 500
    },
    listItemError: {
      paddingTop: 15,
      paddingBottom: 15
    },
    blue: {
      backgroundColor: '#E0F5F7'
    },
    yellow: {
      backgroundColor: '#F7F2C2'
    },
    inline: {
      display: 'inline'
    }
  };
  if ((0, _typeof2["default"])(notification.data.errorTrace) === 'object') {
    notification.data.errorTrace = JSON.stringify(notification.data.errorTrace);
  }
  if (notification.metaID.toUpperCase().includes('ERR')) {
    return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
      style: _objectSpread(_objectSpread(_objectSpread({}, styles.listItem), styles.yellow), styles.listItemError)
    }, /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], {
      styles: styles.listItemIcon
    }, /*#__PURE__*/_react["default"].createElement(_Cancel["default"], {
      style: {
        color: '#414042'
      }
    })), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
      disableTypography: true,
      primary: /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        id: id || testId,
        medium: true,
        customStyle: {
          fontWeight: 600
        }
      }, notification.data.message),
      secondary: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("pre", {
        style: {
          fontFamily: '"AvenirLTPro-Light", sans-serif',
          margin: "5px 0 0 0",
          fontSize: '14px',
          overflowX: 'auto',
          whiteSpace: 'pre-wrap',
          wordWrap: 'break-word',
          overflowWrap: 'anywhere'
        }
      }, notification.data.errorTrace), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        tiny: true,
        margin: "5px 0 0 0"
      }, "".concat(notification.type, " | ").concat(timestamp)))
    }), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
      "aria-label": "delete",
      onClick: function onClick() {
        return _onClick(notification);
      },
      sx: {
        padding: "12px",
        '&.MuiButtonBase-root:hover': {
          backgroundColor: _colors["default"].hoverGrey
        },
        '&.MuiButtonBase-root': _objectSpread({}, customDeleteIcon)
      }
    }, /*#__PURE__*/_react["default"].createElement(_Delete["default"], {
      style: {
        color: '#414042'
      }
    })));
  }
  return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
    style: _objectSpread(_objectSpread({}, styles.listItem), styles.blue)
  }, /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], {
    style: styles.listItemIcon
  }, /*#__PURE__*/_react["default"].createElement(_Error["default"], {
    sx: {
      color: '#414042',
      '&.MuiButtonBase-root:hover': {
        backgroundColor: _colors["default"].hoverGrey
      }
    }
  })), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
    disableTypography: true,
    primary: /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      id: id || testId,
      medium: true,
      customStyle: {
        fontWeight: 600
      }
    }, notification.data),
    secondary: /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      tiny: true
    }, "".concat(notification.type, " | ").concat(timestamp))
  }), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    "aria-label": "delete",
    onClick: function onClick() {
      return _onClick(notification);
    },
    sx: {
      padding: "12px",
      '&.MuiButtonBase-root:hover': {
        backgroundColor: _colors["default"].hoverGrey
      },
      '&.MuiButtonBase-root': _objectSpread({}, customDeleteIcon)
    }
  }, /*#__PURE__*/_react["default"].createElement(_Delete["default"], {
    sx: {
      color: '#414042'
    }
  })));
};

/**
 *
 * @param {*} theme
 */
var _default = exports["default"] = Notification;